"use strict";module.exports={CHARLEROI:10};